import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { ProfitAndLossChartComponent } from './profit-and-loss-chart.component';

@NgModule({
  imports: [CommonModule, MatIconModule, MatProgressSpinnerModule],
  exports: [ProfitAndLossChartComponent],
  declarations: [ProfitAndLossChartComponent],
  providers: [],
})
export class ProfitAndLossChartModule {}
